import { FC, useEffect } from 'react';

import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';
import { useBreakpoints } from 'hooks';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import {
  getSetBusinessPlanType,
} from 'store/useBusinessToolStore/selectors';
import { useUserStore } from 'store/useUserStore';
import { getAuthUser } from 'store/useUserStore/selectors';

export const DeviceTypeObserver: FC = () => {
  const setBusinessPlanType = useBusinessToolStore(getSetBusinessPlanType);

  const { isMobile } = useBreakpoints();
  const authUser = useUserStore(getAuthUser);

  useEffect(() => {
    if (isMobile && !authUser) {
      setBusinessPlanType(BUSINESS_PLAN_TYPES.FOR_BANK);
    }
  }, []);

  return null;
};
